import React, { useState, useEffect, useCallback } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { HashRouter as Router } from 'react-router-dom';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import Recover from './pages/Recover/Recover';
import { Loader } from '@bcmi-labs/react-components';

import './Sso.scss';

function Sso() {
  const urlParams = new URLSearchParams(window.location.search);
  const companyUrl = urlParams.get('company_url');

  const [customDomainInfo, setCustomDomainInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCompany = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_CUSTOM_DOMAIN_API_URL}${companyUrl}`);
      if (response.ok) {
        const result = await response.json();
        setCustomDomainInfo({
          social_logins: [],
          ...result,
        });
        setLoading(false);
      } else {
        setLoading(false);
        throw new Error('Cannot fetch custom domain');
      }
    } catch (e) {
      setLoading(false);
      throw new Error('Cannot fetch custom domain');
    }
  }, [companyUrl]);

  useEffect(() => {
    if (companyUrl) {
      fetchCompany();
    }
  }, [fetchCompany, companyUrl]);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <Switch>
          <Route path="/login">
            <Login customDomainInfo={customDomainInfo} />
          </Route>
          <Route path="/register">
            <Register customDomainInfo={customDomainInfo} />
          </Route>
          <Route path="/recover">
            <Recover customDomainInfo={customDomainInfo} />
          </Route>
          <Route>
            <Redirect to="/login" />
          </Route>
        </Switch>
      )}
    </div>
  );
}

const SsoWrapper = () => (
  <Router basename="/sso">
    <Sso />
  </Router>
);

export default SsoWrapper;
